/**
 * O estado (state) contém as informações reativas do módulo.
 * - visible: controla se o modal/componente do chat está visível.
 * - status: pode controlar o status do chat (online, offline, ocupado).
 */
export const state = {
    visible: false,
    status: 'offline', // Exemplo: pode ser 'online', 'offline', 'busy'
    messages: [],
    userName: 'Visitante',
};

/**
 * Getters são usados para obter dados do estado, podendo computá-los ou filtrá-los.
 * Equivalente às 'computed properties' de um componente.
 */
export const getters = {
    isChatVisible: (state) => state.visible,
    chatStatus: (state) => state.status,
};

/**
 * Mutations são as únicas funções que podem modificar o estado.
 * Devem ser síncronas. O padrão é usar nomes em maiúsculo (SNAKE_CASE).
 */
export const mutations = {
    SET_VISIBILITY(state, isVisible) {
        state.visible = isVisible;
    },
    SET_STATUS(state, newStatus) {
        state.status = newStatus;
    },
    ADD_MESSAGE(state, message) {
        state.messages.push(message);
    },
    SET_USERNAME(state, newName) {
        state.userName = newName;
    },
};

/**
 * Actions são usadas para executar a lógica de negócio e chamar as mutations.
 * Elas podem ser assíncronas.
 */
export const actions = {
    /**
     * Altera a visibilidade do chat.
     * @param {boolean} isVisible - true para mostrar, false para esconder.
     */
    changeVisibility({ commit }, { isVisible }) {
        commit('SET_VISIBILITY', isVisible);
    },

    /**
     * Altera o status do chat.
     * @param {string} status - O novo status (ex: 'online', 'offline').
     */
    changeStatus({ commit }, { status }) {
        commit('SET_STATUS', status);
    },

    /**
     * Envia uma nova mensagem.
     * @param {string} text - O texto da mensagem.
     */
    sendMessage({ commit, state }, { text }) {
        const newMessage = {
            id: Date.now(),
            text: text,
            sender: state.userName,
        };
        commit('ADD_MESSAGE', newMessage);
    },

    /**
     * Altera o nome do usuário do chat.
     * @param {string} newName - O novo nome do usuário.
     */
    changeUsername({ commit }, { newName }) {
        commit('SET_USERNAME', newName);
    },
};